import { apiBaseUrl } from "../services/auth";

export function getAvatarUrl(user) {
  if (!user) return null;
  const raw = user.avatar_url;
  if (typeof raw === "string" && raw.trim()) {
    const trimmed = raw.trim();
    if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
      return trimmed;
    }
    if (trimmed.startsWith("/")) {
      return `${apiBaseUrl}${trimmed}`;
    }
    return trimmed;
  }

  if (user.id) {
    return `${apiBaseUrl}/api/auth/avatar/${user.id}/`;
  }

  return null;
}

export function getInitials(user) {
  const base =
    user?.full_name ||
    `${user?.first_name || ""} ${user?.last_name || ""}`.trim() ||
    user?.email ||
    "";

  const cleaned = String(base).trim();
  if (!cleaned) return "?";

  const parts = cleaned
    .replace(/[@._-]+/g, " ")
    .split(/\s+/)
    .filter(Boolean);

  if (!parts.length) return cleaned.slice(0, 1).toUpperCase();
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (
    parts[0].slice(0, 1) + parts[parts.length - 1].slice(0, 1)
  ).toUpperCase();
}
